import React, { Component } from 'react'

import { Container } from '../../../components/Layout'
import BillingAddBankAccountForm from '../BillingAddBankAccountForm'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'

export default class BillingAddBankAccountFormModal extends Component {
  render() {
    const { modalConfirm, modalCancel, billingAccount } = this.props

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Add Bank Account</div>
          <BillingAddBankAccountForm
            onCancel={modalCancel}
            afterSubmit={modalConfirm}
            billingAccount={billingAccount}
          />
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddBankAccountFormModal/BillingAddBankAccountFormModal.jsx